import { render, staticRenderFns } from "./TableLoadPlaceholder.vue?vue&type=template&id=71338a5e&scoped=true"
import script from "./TableLoadPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./TableLoadPlaceholder.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TableLoadPlaceholder.vue?vue&type=style&index=0&id=71338a5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71338a5e",
  null
  
)

export default component.exports